<template>
  <b-overlay :show="loading">
    <pdf-preview
      v-if="inPreview"
      :inPreview="inPreview"
      :generatingPreview="generatingPreview"
      :saving="saving"
      :pdfUrl="pdfUrl"
      :backToForm="backToForm"
      :save="save"
    />
    <div v-else>
      <form autocomplete="off" @submit.prevent>
        <div class="row">
          <div class="col-12">
            <h2>INFORME DE ACTIVIDADES</h2>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="formType">
                ¿Deseas basarte en otro documento?
              </label>
              <v-select
                v-model="previousDocument"
                :options="createdDocuments"
                name="previousDocument"
                label="label"
                data-cy="created-document-data"
                @input="getDocumentData($event)"
                :clearable="true"
              >
                <template slot="no-options">
                  no hay documentos registrados
                </template>
              </v-select>
              <v-invalid-feedback v-if="$validator.errors.has('formType')">
                {{ $validator.errors.first('formType') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 mb-4" v-if="!attachments || !attachments.length">
            <b-button
              variant="secondary"
              class="btn-icon mt-1 w-100"
              data-cy="from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-repository-file'"
              :disabled="attachments.length >= 1"
            >
              <feather-icon icon="ServerIcon"/>
              Seleccionar CPSH desde el repositorio
            </b-button>
          </div>
          <div
            class="col-12"
            v-for="file in attachments"
            :key="file.id"
            v-if="file && file.name && file.name.includes('CPSH')"
          >
            <div class="row align-items-center">
              <vs-icon class="col-2" icon="description" size="25px" color="primary"/>
              <b class="w-100 text-center col-8">{{ file.name }}</b>
              <vs-button
                class="col-2"
                color="danger"
                type="flat"
                icon="clear"
                @click="removeRepositoryFile(file.id)"
              />
            </div>
          </div>
          <div class="col-12" v-if="!attachments || !attachments.length">
            <span class="danger span-text-validation-danger v-enter-to">
              <small>
                Debes seleccionar un archivo desde el repositorio
              </small>
            </span>
          </div>
        </div>
        <div class="row" v-if="attachments && attachments.length && !loading">
          <div class="col-12">
            <vs-divider/>
          </div>
          <div class="col-6">
            <validate-field
              field="responsibleName"
              label="Nombre colaborador"
              v-slot="{ invalid }"
            >
              <b-input
                name="responsibleName"
                placeholder="Nombre colaborador"
                v-model="formData.responsibleName"
                data-vv-as="nombre"
                data-cy="responsible-name"
                v-validate="'required'"
                :state="invalid"
                disabled
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="responsibleBoss"
              label="Nombre Jefatura"
              v-slot="{ invalid }"
            >
              <b-input
                name="responsibleBoss"
                placeholder="Jefatura"
                v-model="formData.responsibleBoss"
                data-vv-as="jefatura"
                data-cy="responsible-boss"
                v-validate="'required'"
                :state="invalid"
                disabled
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="administrativeSupport"
              label="Soporte administrativo"
              v-slot="{ invalid }"
            >
              <b-input
                name="administrativeSupport"
                placeholder="Soporte administrativo"
                v-model="formData.administrativeSupport"
                data-vv-as="soporte administrativo"
                data-cy="administrative-support"
                v-validate="'required'"
                :state="invalid"
                disabled
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="performanceUnit"
              label="Unidad de desempeño"
              v-slot="{ invalid }"
            >
              <b-input
                name="performanceUnit"
                placeholder="Unidad de desempeño"
                v-model="formData.performanceUnit"
                data-vv-as="Unidad de desempeño"
                data-cy="performance-unit"
                v-validate="'required'"
                :state="invalid"
                disabled
              />
            </validate-field>
          </div>

          <div class="col-6">
            <validate-field
              field="startPeriodDate"
              label="Inicio periodo"
              v-slot="{ invalid }"
            >
              <date-picker
                class="w-100"
                name="startPeriodDate"
                placeholder="Inicio periodo"
                v-model="formData.startPeriodDate"
                data-vv-as="Inicio periodo"
                data-cy="start-period-date"
                v-validate="'required'"
                format='DD/MM/YYYY'
                value-type='DD/MM/YYYY'
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="endPeriodDate"
              label="Fin periodo"
              v-slot="{ invalid }"
            >
              <date-picker
                class="w-100"
                name="endPeriodDate"
                placeholder="Fin periodo"
                v-model="formData.endPeriodDate"
                data-vv-as="Fin periodo"
                data-cy="end-period-date"
                v-validate="'required'"
                format='DD/MM/YYYY'
                value-type='DD/MM/YYYY'
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="decreeNumber"
              label="N° Decreto"
              v-slot="{ invalid }"
            >
              <b-input
                name="decreeNumber"
                placeholder="N° Decreto"
                v-model="formData.decreeNumber"
                data-vv-as="N° Decreto"
                data-cy="decree-number"
                v-validate="'required'"
                :state="invalid"
                disabled
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="feeBillNumber"
              label="N° Boleta de honorario"
              v-slot="{ invalid }"
            >
              <b-input
                name="feeBillNumber"
                placeholder="N° Boleta de honorario"
                v-model="formData.feeBillNumber"
                data-vv-as="N° Boleta de honorario"
                data-cy="fee-bill-number"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6" v-if="isDocenteForm">
            <validate-field
              field="totalHours"
              label="N° horas totales según contrato"
              v-slot="{ invalid }"
            >
              <b-input
                name="totalHours"
                placeholder="N° horas totales según contrato"
                v-model="formData.totalHours"
                data-vv-as="N° horas totales según contrato"
                data-cy="total-hours"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6" v-if="isDocenteForm">
            <validate-field
              field="subjectName"
              label="Nombre de asignatura"
              v-slot="{ invalid }"
            >
              <v-select
                v-model="formData.subjectSelected"
                :options="subjectsCreated"
                name="subjectSelected"
                label="label"
                data-vv-as="Nombre de asignatura"
                data-cy="subject-name"
                multiple
                :v-validate="{ 'required': isDocenteForm }"
                @input="addSubject"
                :clearable="true"
                :class="{'v-select-danger': invalid === false}"
              >
                <template slot="no-options">
                  no hay asignaturas registradas
                </template>
              </v-select>
            </validate-field>

          </div>
          <div class="col-6" v-if="isDocenteForm">
            <validate-field
              field="classSchedule"
              label="Horario de clases"
              v-slot="{ invalid }"
            >
              <v-select
                :options="schedulesCreated"
                name="scheduleSelected"
                label="label"
                placeholder="Horario de clases"
                v-model="formData.classScheduleSelected"
                data-vv-as="Horario de clases"
                data-cy="class-schedule"
                :v-validate="{ 'required': isDocenteForm }"
                multiple
                @input="addSchedule"
                :clearable="true"
                :class="{'v-select-danger': invalid === false}"
              >
                <template slot="no-options">
                  no hay horarios registrados
                </template>
              </v-select>
            </validate-field>
          </div>
          <div class="col-6" v-if="isDocenteForm">
            <validate-field
              field="totalEffectiveHours"
              label="N° de horas efectivas"
              v-slot="{ invalid }"
            >
              <b-input
                name="totalEffectiveHours"
                placeholder="N° de horas efectivas"
                v-model="formData.totalEffectiveHours"
                data-vv-as="N° de horas efectivas"
                data-cy="total-effective-hours"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <h4>DATOS DE TRANSFERENCIA</h4>
          </div>
          <div class="col-6">
            <validate-field
              field="bank"
              label="Banco"
              v-slot="{ invalid }"
            >
              <b-form-select
                :disabled="loadingBankOptions"
                class="w-100"
                v-model="formData.bank"
                data-vv-as="Banco"
                data-cy="bank"
                :state="invalid"
                name="bank"
                v-validate="'required'"
                :options="bankOptions"
              >
                <option
                  :value="null"
                  disabled
                >
                  {{ bankLoadingText }}
                </option>
              </b-form-select>
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="bankAccountType"
              label="Tipo de cuenta"
              v-slot="{ invalid }"
            >
              <b-form-select
                name="bankAccountType"
                class="w-100"
                placeholder="Tipo de cuenta"
                v-model="formData.bankAccountType"
                data-vv-as="Tipo de cuenta"
                data-cy="bank-account-type"
                v-validate="'required'"
                :state="invalid"
                :options="bankAccountTypes"
              >
                <option value="" disabled>-- Selecciona un tipo de cuenta --</option>
              </b-form-select>
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="bankAccountNumber"
              label="N° de cuenta"
              v-slot="{ invalid }"
            >
              <b-input
                name="bankAccountNumber"
                placeholder="N° de cuenta"
                v-model="formData.bankAccountNumber"
                data-vv-as="N° de cuenta"
                data-cy="bank-account-number"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <h4>ACTIVIDADES REALIZADAS O PRODUCTO ENTREGADO EN EL MES INFORMADO</h4>
          </div>
          <div class="col-12 col-lg-12">
            <div
              class="wrap-functions"
              v-for="(service, index) in formData.activities"
              :key="`key-${index}`"
            >
              <b>Función {{ index + 1 }}:</b> {{ service.task }}
            </div>
          </div>
          <div class="col-12 mt-10">
            <vs-table
              class="wrap-table shadow"
              hoverFlat
              :data="(formData.activitiesPeriod || [])"
              noDataText="No hay actividades aún"
            >
              <template>

                <thead>
                <th colspan="3" class="text-center">
                  <h4>ACTIVIDADES REALIZADAS O PRODUCTO ENTREGADO EN EL MES INFORMADO</h4>
                </th>
                </thead>
                <tbody>
                <vs-tr v-for="(_, index) in formData.activitiesPeriod" :key="index">
                  <vs-td class="table-part">
                    <b-form-group>
                      <label for="relatedActivity">
                        Cometidos
                        <span v-html="required('activitiesPeriod[' + index + '].relatedActivity')"/>
                      </label>
                      <v-select
                        :class="{'v-select-danger': $validator.errors.has('activities[' + index + '].relatedActivity')}"
                        :data-cy="'activitiesPeriod[' + index + '].relatedActivity'"
                        :name="'activitiesPeriod[' + index + '].relatedActivity'"
                        data-vv-as='cometido'
                        placeholder='Cometido...'
                        v-model="formData.activitiesPeriod[index].relatedActivity"
                        :state="$validator.errors.has('activitiesPeriod[' + index + '].relatedActivity')? false : null"
                        :danger="$validator.errors.has('activitiesPeriod[' + index + '].relatedActivity')"
                        :danger-text="$validator.errors.first('activitiesPeriod[' + index + '].relatedActivity')"
                        v-validate="'required'"
                        :options="formData.activitiesSelect"
                        @input="formData.activitiesPeriod[index].nameActivity = $event.label"
                      />
                      <v-invalid-feedback
                        v-if="$validator.errors.has('activitiesPeriod[' + index + '].relatedActivity')">
                        {{ $validator.errors.first('activitiesPeriod[' + index + '].relatedActivity') }}
                      </v-invalid-feedback>
                    </b-form-group>
                  </vs-td>
                  <vs-td>
                    <b-form-group>
                      <label :for="`activitiesPeriod[${index}].descriptionActivity`">
                        Descripción de la función
                        <span v-html="required('activitiesPeriod[' + index + '].descriptionActivity')"/>
                      </label>
                      <b-form-textarea
                        rows="3"
                        :name="`activitiesPeriod[${index}].descriptionActivity`"
                        :data-cy="`activitiesPeriod[${index}].descriptionActivity`"
                        data-vv-as="descripción de la función"
                        placeholder="Descripción de la función y/o producto realizado"
                        v-model="formData.activitiesPeriod[index].descriptionActivity"
                        :danger="$validator.errors.has(`activitiesPeriod[${index}].descriptionActivity`)"
                        v-validate="'required'"

                      />
                      <v-invalid-feedback
                        v-if="$validator.errors.has('activitiesPeriod[' + index + '].descriptionActivity')">
                        {{ $validator.errors.first('activitiesPeriod[' + index + '].descriptionActivity') }}
                      </v-invalid-feedback>
                    </b-form-group>
                  </vs-td>
                  <vs-td class="align-middle">
                    <vs-button
                      class="-mb-3"
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeActivity(index)"
                    />
                  </vs-td>
                </vs-tr>
                </tbody>
                <tfoot>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-button
                      class="w-100"
                      color="primary"
                      type="border"
                      icon="add"
                      @click="addActivity"
                    >
                      Agregar Actividad
                    </vs-button>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="3">
                    <v-invalid-feedback data-cy="activitiesError" v-if="activitiesError">
                      {{ activitiesError }}
                    </v-invalid-feedback>
                  </vs-td>
                </vs-tr>
                </tfoot>
              </template>
            </vs-table>
          </div>
          <div class="col-12 mt-2">
            <b-form-group>
              <label for="experience">
                Observaciones
                <span v-html="required('notes')"/>
              </label>
              <b-form-textarea
                rows="3"
                data-cy="observaciones"
                name="notes"
                data-vv-as="Observaciones"
                placeholder="Observaciones..."
                v-model="formData.notes"
                :state="$validator.errors.has('notes') ? false : null"
                :danger="$validator.errors.has('notes')"
                :danger-text="$validator.errors.first('notes')"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('notes')">
                {{ $validator.errors.first('notes') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <h4>Documentos</h4>
          </div>
          <div class="col-12">
            <dynamic-file-selector
              v-if="!actAttachmentsSelectors.loading"
              :selectors="actAttachmentsSelectors.list
              .slice()
              .sort((a, b) => a.order - b.order)
               .map((sel) => ({ ...sel, ...sel.extra, index: sel.order }))
            "
              :object-to-evaluate="formData"
              :files="dynamicSelectorFiles"
              :reset-key="dfsResetKey"
              @update-files="updateFiles"
              @valid="(valid) => {
              dynamicFileSelectorValid = valid;
            }"
            />
            <div v-else>
              <b-skeleton animation="fade" width="100%"/>
              <b-skeleton animation="fade" width="100%"/>
            </div>
          </div>
          <div class="col-12 text-right" v-if="error.message !== ''">
            <v-invalid-feedback>
              {{ error.message }}
            </v-invalid-feedback>
          </div>
        </div>
      </form>
      <small>
        <b>Los campos marcados con <span class="text-danger">*</span> son obligatorios</b>
      </small>
      <form-action-buttons
        :saving="saving"
        :preview="preview"
        :back="back"
        :save="save"
        :saveDraft="saveDraft"
      />
      <repository-selector
        :add-file="addRepositoryFile"
        :files="attachments"
        :remove-file="removeRepositoryFile"
        :max-files="1"
        required-file-type="CPSH"
        :required-approval-state="approvalStateTypes.APPROVED"
      />
    </div>
  </b-overlay>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapActions, mapGetters } from 'vuex';

import HandlePreLoadData from "@/febos/global/documentManagement/mixins/HandlePreLoadData";
import { showInvalidFormNotification } from '@/febos/global/customDocuments/utils/notifications';
import { scrollToNamedElement } from '@/febos/global/customDocuments/utils/scroll';
import { showToast } from '@/febos/global/customDocuments/utils/showToast';
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import PdfPreview from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/PdfPreview.vue';
import VInvalidFeedback from '@/febos/global/customDocuments/components/VInvalidFeedback.vue';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import RepositorySelector from '@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue';
import ValidateField from '@/febos/global/customDocuments/components/ValidateField.vue';
import { FORM_TYPE } from '@/febos/global/customDocuments/vistas/empresas/61980520-8/constants';
import VSelectSubject from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectSubject.vue';
import FormActionButtons
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/FormActionButtons.vue';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import DynamicFileSelector
from '@/febos/global/customDocuments/components/dynamic-file-selector/DynamicFileSelector.vue';
import { getAttachmentsConfig } from '@/febos/global/customDocuments/utils/attachments';
import HandleDraft from '@/febos/global/documentManagement/mixins/HandleDraft';

const DOC_TYPE = 'ACT';

export default {
  name: DOC_TYPE,
  components: {
    FormActionButtons,
    VSelectSubject,
    ValidateField,
    RepositorySelector,
    VInvalidFeedback,
    DatePicker,
    PdfPreview,
    DynamicFileSelector,
  },
  mixins: [HandleDraft, HandlePreLoadData],
  data() {
    return {
      bankAccountTypes: ['Cuenta Vista', 'Cuenta Corriente', 'Cuenta de Ahorro'],
      loadingBankOptions: false,
      bankOptions: [],
      dynamicFileSelectorValid: false,
      dynamicSelectorFiles: [],
      dfsValid: true,
      dfsSelectors: [],
      dfsSelectorsLoading: true,
      dfsFiles: [],
      formFiles: [],
      formData: {
        attachments: [],
        activities: [],
        notes: '',
        responsibleName: '',
        responsibleBoss: '',
        administrativeSupport: '',
        performanceUnit: '',
        workingDayType: '',
        startPeriodDate: '',
        endPeriodDate: '',
        decreeNumber: '',
        feeBillNumber: '',
        totalHours: '',
        subjectName: '',
        totalEffectiveHours: '',
        bank: '',
        bankAccountType: '',
        bankAccountNumber: '',
        workHoursAndRemuneration: [],
        activitiesPeriod: [{
          relatedActivity: '',
          nameActivity: '',
          descriptionActivity: '',
        }],
        subjectSelected: [],
        classScheduleSelected: [],
        subjects: [],
        classSchedules: [],
        formType: '',
      },
      saving: false,
      error: {
        message: ''
      },
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',
      attachments: [],
      activitiesError: '',
      loading: false,
      workHoursActivities: [],
      approvalStateTypes: ApprovalStateTypes,
      subjectsCreated: [],
      schedulesCreated: [],
      isDocenteForm: false,
    };
  },
  computed: {
    ...mapGetters('List', [
      'actAttachmentsSelectors',
    ]),
    ...mapGetters('Usuario', ['currentUser']),
    bankLoadingText() {
      return this.loadingBankOptions
        ? 'Cargando bancos'
        : '-- Selecciona un banco --';
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchActAttachmentsSelectors',
      'fetchUsers'
    ]),
    updateFiles(files) {
      this.formFiles = [...files];
      this.formData.attachments = [...files];
    },
    async loadBanks() {
      try {
        this.loadingBankOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'bancos-ed',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.bankOptions = opciones.map((option) => ({
          value: option.valor,
          text: option.descripcion,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } finally {
        this.loadingBankOptions = false;
      }
    },
    required(fieldName) {
      const item = this.$validator.fields.items.find((_item) => _item.name === fieldName);
      if (!item || !item.rules || !Object.keys(item.rules).length || !Object.keys(item.rules).includes('required')) {
        return '';
      }
      return "<span class='text-danger'><b>*</b></span>";
    },
    removeActivity(index) {
      if (this.formData.activitiesPeriod.length === 1) {
        this.formData.activitiesPeriod = [{
          relatedActivity: '',
          nameActivity: '',
          descriptionActivity: '',
        }];
        return;
      }
      this.formData.activitiesPeriod.splice(index, 1);
    },
    addSubject(event) {
      this.formData.subjects = event;
    },
    addSchedule(event) {
      this.formData.classScheduless = event;
    },
    addActivity() {
      this.formData.activitiesPeriod.push({
        relatedActivity: '',
        nameActivity: '',
        descriptionActivity: '',
      });
    },
    async getSelectedFileData(file) {
      console.log('FIELEEEE', file);
      try {
        this.loading = true;
        const { id } = file;
        const { data: { document } } = await ioGetCustomDocument('CPSH', id, {});

        this.formData.activities = document.specificLaborArray || [];
        this.formData.activitiesSelect = (document.specificLaborArray || []).map((task, index) => ({
          id: index,
          label: task.task,
          value: task.task
        }));
        this.formData.formType = document.formType;
        this.formData.linked = [
          {
            id: document.id,
            locationId: document.locationId,
            locationType: document.locationType,
          }
        ];
        this.isDocenteForm = document.formType === FORM_TYPE.DOCENTE;
        this.formData.responsibleName = this.currentUser.nombre;
        this.formData.responsibleEmail = this.currentUser.correo;
        this.formData.responsibleNameCpch = document.createdName;
        this.formData.responsibleEmailCpch = document.email;
        this.formData.responsibleBoss = document.administrativeResponsibleComplete
          ? document.administrativeResponsibleComplete.label : document.administrativeResponsible;
        this.formData.administrativeSupport = document.administrativeSupportComplete
          ? document.administrativeSupportComplete.label : document.administrativeSupport;
        this.formData.performanceUnit = document.groupBelongsUser && typeof document.groupBelongsUser === 'object'
          ? document.groupBelongsUser.nombre
          : document.groupBelongsUser || '';
        this.formData.decreeNumber = document.numero;
        this.formData.totalHours = document.serviceHours;
        this.subjectsCreated = document.workHoursAndRemuneration.map((item) => ({
          id: item.subjectCode,
          label: `(${item.subjectCode}) - ${item.subjectName}`,
          value: `(${item.subjectCode}) - ${item.subjectName}`,
        }));

        this.formData.administrativeResponsibleComplete = document.administrativeResponsibleComplete;
        this.formData.otherResponsibleComplete = document.otherResponsibleComplete;
        this.formData.administrativeSupportComplete = document.administrativeSupportComplete;

        if (document.schedules) {
          this.schedulesCreated = document.schedules.map((item) => ({
            id: `${item.day} (${item.hour[0]} - ${item.hour[1]})`,
            label: `${item.day} (${item.hour[0]} - ${item.hour[1]})`,
            value: `${item.day} (${item.hour[0]} - ${item.hour[1]})`,
          }));
        }
      } catch (e) {
        console.log('error', e);
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.$validator.validateAll();
        });
      }
    },
    async addRepositoryFile(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.attachments.push(file);
      this.error.message = '';

      await this.getSelectedFileData(file);
    },
    removeRepositoryFile(id) {
      this.attachments = this.attachments.filter((file) => file.id !== id);
    },
    // others
    back() {
      window.history.back();
    },
    async validateForm() {
      this.$validator.errors.clear();
      const fieldsValid = await this.$validator.validateAll();
      const validDynamicFileSelector = this.dynamicFileSelectorValid;

      const result = !!fieldsValid
        && validDynamicFileSelector;

      this.error.message = '';
      if (this.formData.totalEffectiveHours > this.formData.totalHours) {
        this.error.message = 'El número de horas efectivas no puede ser mayor al número de horas totales según contrato';
        return;
      }

      if (!result) {
        showInvalidFormNotification(this);
        scrollToNamedElement(this.$validator?.errors?.items[0]?.field);
      }

      return result;
    },
    async generatePdf(id) {
      showToast(this, 'Generando archivo PDF', 'En camino...');
      const response = await ioGetCustomDocument(this.$route.params.type, id, { pdf: 'si' });
      showToast(this, 'Archivo generado', 'Listo!', { variant: 'success', autoHideDelay: 3000 });
      window.open(response.data.pdf, '_blank');
      setTimeout(() => window.history.back(), 2000);
    },
    getFormData() {
      return {
        ...this.formData,
        cpshFilesSelected: this.attachments,
      };
    },
    backToForm() {
      this.inPreview = false;
    },
    async preview() {
      const isValid = await this.validateForm();
      if (!isValid || !this.attachments || !this.attachments.length) {
        return;
      }

      this.pdfUrl = '';
      this.inPreview = true;
      this.generatingPreview = true;

      try {
        showToast(this, 'Generando previsualización', 'En camino...', 'primary', 3000);

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.getFormData(),
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          showToast(this, 'No se pudo generar la previsualización', 'Ups!', 'warning', 5000);
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } finally {
        this.generatingPreview = false;
      }
    },
    async save() {
      this.$validator.errors.clear();
      const isValid = await this.validateForm();
      if (!isValid) {
        return;
      }

      this.error.message = '';
      this.saving = true;
      const from = this.$route.query?.from;
      try {
        showToast(this, 'Guardando documento', 'En camino...', 'primary', 2000);
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'si',
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            status: 1,
            ...this.getFormData()
          },
        };

        console.log('SAVEEE', payload);

        const response = await ioCreateCustomDocument(payload);
        await this.notifyCreation(response.data.name || '');
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async saveDraft() {
      this.$validator.errors.clear();

      const { from } = this.$route.query;
      this.error.message = '';
      this.saving = true;

      try {
        showToast(this, 'Guardando borrador', 'En camino...', 'primary', 2000);
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'no',
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            ...this.getFormData(),
            status: '3',
          },
        };
        const response = await ioCreateCustomDocument(payload);
        const docId = response.data?.document?.id || response.data?.documentId;
        if (docId) {
          await this.updateRouteAsDraft(docId);
        }
        showToast(this, 'Borrador guardado correctamente', '¡Listo!', 'success', 3000);
      } finally {
        this.saving = false;
      }
    },
    removeAttachment(file) {
      this.formData.attachments = this.formData.attachments.filter((file) => file.id !== id);
    },
    async loadAttachmentsConfig() {
      this.dfsSelectorsLoading = true;
      try {
        const { selectors } = await getAttachmentsConfig(DOC_TYPE);
        this.dfsSelectors = selectors;
      } finally {
        this.dfsSelectorsLoading = false;
        this.dfsValid = false;
      }
    },
  },
  created() {
    this.loadBanks();
    this.loadAttachmentsConfig();
    this.fetchActAttachmentsSelectors();
  }
};
</script>
<style>
.wrap-functions {
  border: 1px solid #673ab721;
  border-radius: 5px;
  padding: 6px 5px;
  margin: 4px 0;
}
</style>
